import get from 'lodash/get'
import {createSelector} from 'reselect'
import first from 'lodash/first'
import {ROLES} from '../models/enums'

export const getAuthenticated = (state) => get(state, ['account', 'authenticated']);
export const getAccount = (state) => get(state, ['account', 'account']);

export const getAccountProfile = createSelector(getAccount, (account) => get(account, ['idTokenPayload']));

//export const getAccountVerified = createSelector(getAccountProfile, (profile) => get(profile, ['email_verified']));
export const getAccountVerified = (state) => true;
export const getAccountEmail = createSelector(getAccountProfile, (profile) => get(profile, ['email']));
export const getAccountToken = createSelector(getAccount, (account) => get(account, ['accessToken']));
export const getRole = createSelector(getAccountProfile, (profile) => profile && first(profile['http://portal.evoenergy/claims/roles']));
export const getRoles = createSelector(getAccountProfile, (profile) => profile && profile['http://portal.evoenergy/claims/roles']);
export const getGroups = createSelector(getAccountProfile, (profile) => profile && profile['http://portal.evoenergy/claims/groups']);
export const getPermissions = createSelector(getAccountProfile, (profile) => profile && profile['http://portal.evoenergy/claims/permissions']);
export const getIsContractor = createSelector(getRole, (role) => role === ROLES.Contractor);
export const getIsEmployee = createSelector(getRole, (role) => role === ROLES.Employee);
export const getIsCustomer = createSelector(getRole, (role) => role === ROLES.Customer);


// WEBPACK FOOTER //
// ./src/selectors/account.js